import React, {useState, useEffect} from 'react';
import { QueryContext } from '../../context/query';
import { TableContext } from '../../context/table';
import Stylesheet from './Visual.module.css';
import {Bar, Line} from 'react-chartjs-2';
import Loading from '../../../Spinner/Standard/Standard';

const Visual = (props) => {
    let table = null;
    let query = null;
    const [lables, setLables] = useState([]);
    const [data, setData] = useState([]);
    const [groupColumn, setGroupColumn] = useState(null);
    const init = (tableContext, queryContext) => {
        table = tableContext;
        query = queryContext;
    }
    useEffect(() => {
        // check if report was closed
        if (!query.report.report) return;
        // identify lables
        // and data
        const resultRecords = query.report.records;
        const groupFilter = query.report.report.filters[0];
        // identify refference collumn
        const primaryColumn = table.schema.find(({name}) => name === groupFilter.column)
        const lables = [];
        const data = [];
        // identify unique groups in the resulting records with the selected column
        for (const record of resultRecords) {
            const lableIndex = lables.findIndex((title) => 
            title === record[primaryColumn.name]);
            if (lables.findIndex((title) => 
            title === record[primaryColumn.name]) === -1) {
                lables.push(record[primaryColumn.name]);
                data.push(1);
            } else {
                data[lableIndex] += 1;
            }
                
        }
        setGroupColumn(primaryColumn);
        setLables(lables);
        setData(data);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props]);

    const content = () => {
        // check if report was closed
        if (!query.report.report) {
            query.setConfig({...table.config, 
            visualizationMode: !table.config.visualizationMode});
            return null;
        }
        if (lables.length === 0 || data.length === 0) {
            return (
                <div className={Stylesheet.Loading}>
                    <Loading show/>
                </div>
            )
        }
        const state = {
            labels: lables,
            datasets: [{
                label: groupColumn.title,
                backgroundColor: 'rgba(9, 132, 227, .8)',
                borderColor: 'rgba(0,0,0,1)',
                borderWidth: 1,
                data: data
              }]
          }
          console.log(query.report.report)
        return (
            <React.Fragment>
                <div className={Stylesheet.Header}>
                    <h3>{query.report.report.title}</h3>
                    <h4>{query.report.report.description}</h4>
                </div>
                <div className={Stylesheet.Graphs}>
                    <div className={Stylesheet.Bar}>
                        <Bar
                        data={state}
                        options={{
                            responsive: true,
                            title:{
                                display:true,
                                text: query.report.report.title
                            },
                            legend:{display:true,position:'right'}
                        }}
                        />
                    </div>
                    <div className={Stylesheet.Pie}>
                        <Line
                        data={state}
                        options={{
                            title:{
                            display:true,
                            text: query.report.report.title,
                            fontSize:20
                            },
                            legend:{
                            display:true,
                            position:'right'
                            }
                        }}
                        />
                    </div>
                </div>
            </React.Fragment>
        )
    }
    return (
        <TableContext.Consumer>
            {table => (
                <QueryContext.Consumer>
                    {query => (
                        <div className={Stylesheet.Container}>
                            {init(table, query)}
                            {content()}
                        </div>
                    )}
                </QueryContext.Consumer>
            )}
        </TableContext.Consumer>
    )
}

export default Visual;